import { UserType } from 'interfaces/user';
import { useLocation } from 'react-router';
import {
  FRESHMARK_ADMIN_PROFILE_ID,
  getPrefixedRoute,
  INPUTS_ADMIN_PROFILE_ID,
  NILE_ADMIN_PROFILE_ID,
  VILLA_ADMIN_PROFILE_ID,
} from 'services/theming';
import { paths } from 'config/paths';
import useUser from './useUser';

const ADMIN_CONTEXT_PROFILE_IDS = [
  NILE_ADMIN_PROFILE_ID,
  FRESHMARK_ADMIN_PROFILE_ID,
  INPUTS_ADMIN_PROFILE_ID,
  VILLA_ADMIN_PROFILE_ID,
];

/**
 * Returns the path to use for "shipments" redirects: /sales for admin users,
 * /shipments for non-admin (shipments route is no longer an option for admins).
 */
export const useShipmentsOrSalesPath = () => {
  const { user } = useUser();

  const { search } = useLocation();
  const profileID = new URLSearchParams(search).get('profileID');
  const isAdmin = user?.userType === UserType.Admin;

  const isAdminSellerView = isAdmin && profileID && !ADMIN_CONTEXT_PROFILE_IDS.includes(Number(profileID ?? '0'));

  return isAdmin && !isAdminSellerView ? paths.sales() : paths.shipments();
};

/**
 * Same as useShipmentsOrSalesPath but for a given route prefix (e.g. '/villa', '/inputs', or '' for nile).
 * Use when redirecting to a different theme than the current one. Uses getPrefixedRoute so prefix logic matches paths config.
 */
export const useShipmentsOrSalesPathForPrefix = (prefix: string) => {
  const useSales = useShipmentsOrSalesPath().endsWith('/sales');
  return getPrefixedRoute(useSales ? '/sales' : '/shipments', prefix);
};
